<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading && !error">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<template v-if="page == 'track'">
					<userlist/>
				</template>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
			<div class="loading" v-if="error">Please disable your Ad blocking plugin and refresh the page.</div>
		</div>
	</main>
</template>

<script>
//importing widgets
import textcontent from '../components/widgets/text'
import userlist from '../components/track/userlist'

export default {
	components: {
		textcontent,
		userlist
	},
	props:['type'],
	name: 'trackpage',
	watch:{ // watching for route change
		$route (to, from){
			this.$nextTick(() => {
				this.getPagedata()
			})
		}
	},
	computed: { // setting list of widgets
		widgets() {
			return this.components
		}
	},
	data() {
		return {
			ps:null,
			page:'',
			pageData:[],
			components:[],
			comp:[],
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true,
			error: false
		}
	},
	mounted: function() {
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.page = this.urlCheck('last')
			let url = this.type == 'subsection' || this.urlCheck('first') ? 'subsection/' : 'section/'
			this.axios.get(process.env.VUE_APP_URL+url+this.page, {params:{name:this.page, language:this.lang}})
			.then(response => {
				this.pageData = response.data
				this.prepareComponents()
			})
			.catch(error => {
				this.loading = false
				this.error = true
			})
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
				this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
				this.perfectScrollInit()
			})
		},
		urlCheck: function(type) { // checking path for 3 level menu and getting menu name
			let url = this.$route.path.split('/')
			return type == 'last' ? url[url.length-1] : url.length > 3 ? true : false
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>